import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
const valueItems = [{
  item: "📘 Your Baby's First Year — B.A.B.Y. 365 Protocol (60 pages)",
  value: '$97'
}, {
  item: '🌙 BONUS 1: Golden Nights',
  value: '$57'
}, {
  item: '🧠 BONUS 2: Little Genius (52 activities)',
  value: '$37'
}, {
  item: '📅 BONUS 3: Your Baby Month by Month',
  value: '$27'
}, {
  item: '💰 BONUS 4: Save $2000 in their First Year',
  value: '$17'
}];
interface ValueStackSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function ValueStackSection({
  onBuyClick
}: ValueStackSectionProps) {
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-377">
      <div className="max-w-[900px] mx-auto" data-id="element-378">
        <div className="text-center mb-10" data-id="element-379">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-380">
            Everything you get today
          </span>
          <h2 className="text-3xl md:text-4xl text-[#FAF7F2] leading-tight" data-id="element-381">
            The Complete B.A.B.Y. 365 Bundle
          </h2>
        </div>

        <table className="w-full border-collapse mb-10" data-id="element-382">
          <tbody data-id="element-383">
            {valueItems.map((item, idx) => <tr key={idx} className="border-b border-white/10 last:border-b-0" data-id="element-384">
                <td className="py-4 px-3 font-sans text-sm text-[rgba(250,247,242,0.9)]" data-id="element-385">
                  {item.item}
                </td>
                <td className="py-4 px-3 text-[#C9A96E] font-bold text-right text-base" data-id="element-386">
                  {item.value}
                </td>
              </tr>)}
            <tr className="border-t-2 border-[rgba(183,110,121,0.4)]" data-id="element-387">
              <td className="pt-5 px-3 font-sans text-lg text-[#FAF7F2] font-bold" data-id="element-388">
                💎 TOTAL VALUE
              </td>
              <td className="pt-5 px-3 text-[#FAF7F2] font-bold text-right text-lg" data-id="element-389">
                $235
              </td>
            </tr>
          </tbody>
        </table>

        <div className="bg-white/5 rounded-3xl p-9 border border-[rgba(183,110,121,0.3)] text-center" data-id="element-390">
          <div className="text-xl text-[rgba(250,247,242,0.5)] line-through mb-2 font-sans" data-id="element-391">
            Total value: $235
          </div>
          <div className="text-6xl md:text-7xl font-bold text-[#FAF7F2] leading-none mb-1.5" data-id="element-392">
            $12.97
          </div>
          <div className="inline-block bg-[#B76E79] text-white text-sm font-bold px-4 py-1.5 rounded-full mb-5 font-sans" data-id="element-393">
            💰 YOU SAVE $222.03 — 95% OFF
          </div>

          <p className="text-sm text-[rgba(250,247,242,0.75)] font-sans leading-relaxed max-w-[520px] mx-auto mb-3 italic" data-id="element-394">
            Why only $12.97? Because we're in our 2026 founding launch. We're
            looking for our first 500 families to experience the protocol, share
            their results, and help us grow. Once we reach 500 founding members,
            this price closes permanently.
          </p>

          <p className="text-base text-[#FAF7F2] font-sans font-bold mb-6" data-id="element-395">
            You're not getting a discount. You're getting founding member
            access.
          </p>

          <a href={CHECKOUT_URL} onClick={onBuyClick} className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse" data-id="element-396">
            ⚡ YES, I WANT FULL ACCESS FOR $12.97 →
          </a>

          <div className="flex justify-center gap-5 flex-wrap mt-5 text-xs text-[rgba(250,247,242,0.6)] font-sans" data-id="element-397">
            <span className="flex items-center gap-1.5" data-id="element-398">
              🔒 Secure SSL Payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-399">
              📥 Immediate Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-400">
              ↩️ 30-Day Guarantee
            </span>
            <span className="flex items-center gap-1.5" data-id="element-401">
              💳 Visa · PayPal · Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}